import { getCurrencyMinorUnitExponent } from './getCurrencyMinorUnitExponent';

export function amountToBaseUnits(amount: number, currency: string): number {
	return Math.round(amount * 10 ** getCurrencyMinorUnitExponent(currency));
}
